import React, { useState } from 'react';
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
import CustomCloseButton from '../Components/CustomCloseButton';
import { useAuth } from '../Context/AuthContext';
import { toast } from 'react-toastify';

import {inputMaxLengths} from '../HelperFunctions/InputMaxLengths';

import { db } from '../firebase-config';
import { collection, addDoc } from "firebase/firestore"; 

const CreateClientModal = (props)=>{
    const { setShowSpinner } = useAuth();

    const [customer, setCustomer] = useState("");
    const [truckCharge, setTruckCharge] = useState(0);
    const [hourlyRate, setHourlyRate] = useState(0);
   
  
    const validateForm = async ()=>{
        if (customer !== '') {
            setShowSpinner(true);
            // save to database client_information
            // new document (dynamically generate id)
            try{
                const docRef = await addDoc(collection(db, 'client_information'), {
                    "Customer": customer,
                    "Hourly Rate": hourlyRate === "" ? 0 : parseFloat(hourlyRate),
                    "Truck Charge": truckCharge === "" ? 0 : parseFloat(truckCharge),
                    "Invoices": [],
                    "Locations": []
                });
                toast.success(`Client ${customer} has been saved to the database with id ${docRef.id}`)
                const newClientInfo = {
                    "Customer": customer,
                    "Hourly Rate": hourlyRate === "" ? 0 : parseFloat(hourlyRate),
                    "Truck Charge": truckCharge === "" ? 0 : parseFloat(truckCharge),
                    "Invoices": [],
                    "Locations": [],
                    "id": docRef.id
                }
                setCustomer("");
                setTruckCharge(0);
                setHourlyRate(0);
                props.onHide('new client', newClientInfo);
                setShowSpinner(false)
            }catch (error){
                toast.error(`Failed to save new client: ${error.message}`)
                setShowSpinner(false)
            }
        }else{
            toast.warn('Not all required information is filled out. Please review form.');
        }
    };

    return(
        <Modal
            {...props}
            size="lg"
            animation={false}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>CREATE NEW CUSTOMER PROFILE</Modal.Title>
                <div onClick={()=>{
                    setCustomer("");
                    setTruckCharge(0);
                    setHourlyRate(0);
                    props.onHide('show cancel')
                }} variant="none">
                    <CustomCloseButton/>
                </div>
            </Modal.Header>
            <Modal.Body>
                <Container fluid style={{marginTop:"20px"}}>
                    <Row>
                        <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                            <Row style={{marginBottom: "20px"}}>
                                <Col>CUSTOMER INFORMATION</Col>
                            </Row>
                            
                            <Row style={{marginLeft:"10px"}}><Col>CUSTOMER:*</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={customer} maxLength={inputMaxLengths.customer} onChange={(e)=> setCustomer(e.target.value)}/></Col></Row>
                            <Row style={{marginLeft:"10px"}}><Col>TRUCK CHARGE:</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" value={truckCharge} onChange={(e)=> setTruckCharge(e.target.value)}/></Col></Row>
                            <Row style={{marginLeft:"10px"}}><Col>HOURLY RATE:</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" value={hourlyRate} onChange={(e)=> setHourlyRate(e.target.value)} /></Col></Row>
                            
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    className="btn-dark"
                    style={{backgroundColor:"#2596be"}}
                    onClick={()=>{
                        validateForm(props);
                    }}
                >
                    Save
                </Button>
                <Button 
                    className="btn-dark"
                    style={{backgroundColor:"#2596be"}}
                    onClick={()=>{
                        setCustomer("");
                        setTruckCharge(0);
                        setHourlyRate(0);
                        props.onHide('show cancel');
                    }}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default CreateClientModal;